import {ACTIONS} from '../01-actions/system';

const initialState = {
	systemStatus: null,
	
};

export default (state = initialState, action) => {
	switch (action.type) {
		case ACTIONS.UPDATE_SETTING_PROGRESS:
		case ACTIONS.FETCH_STATUS_PROGRESS:
			return {
				...state,
				status: action.type
			};
		case ACTIONS.UPDATE_SETTING_FAILED:
		case ACTIONS.FETCH_STATUS_FAILED:
			return {
				...state,
				status: action.type,
				error: action.data.error
			};
		case ACTIONS.FETCH_STATUS_SUCCESS:
			return {
				...state,
				status: action.type,
				systemStatus: action.data.systemStatus
			};
		case ACTIONS.UPDATE_SETTING_SUCCESS:
			return {
				...state,
				status: action.type,
				systemStatus: {
					...state.systemStatus,
					[action.data.setting.name]: action.data.setting.value
				}
			};
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/02-reducers/system.js